/**
 * Checks if the current app instance is from the phone application
 */

const isPhoneApp = () => {
    return !!window.ReactNativeWebView
}

export default isPhoneApp;